// MainImage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../Components/Button';
import backimage from "../../Assets/Images/1stpic.jpg";
import './MainImage.css'; // <-- Import CSS

function MainImage() {
  const navigate = useNavigate();

  return (
    <div className="main-image-container">
      <div
        className="main-image-box"
        style={{ backgroundImage: `url(${backimage})` }}
      >
        <div className="main-image-content">
          <h1 className="main-title">
            WaterSprint — <span className="block sm:inline">Science. Software. Satellites.</span>
          </h1>
          <p className="main-subtitle">
            Delivering cutting-edge data intelligence and innovative solutions for a sustainable{' '}
            <br className="hidden sm:block" /> future.
          </p>
          <div className="main-buttons">
            <Button buttonname="Services" onClick={() => navigate('/Services')} />
            <Button buttonname="Our Products" onClick={() => navigate('/OurProduct')} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainImage;